export default __webpack_public_path__ + "static/media/temp.4ab7191c.JPG";